import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MIDDLEWARE_URL = process.env.REACT_APP_API_URL;


export default function Avoirs() {
  const navigate = useNavigate();
  const [avoirs, setAvoirs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(null);
  const [toast, setToast] = useState(null);
  const [numInput, setNumInput] = useState("");
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    fetch(`${MIDDLEWARE_URL}/avoirs`)
      .then((r) => r.json())
      .then((d) => { setAvoirs(Array.isArray(d) ? d : d.avoirs || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3500);
  };

  const createAvoir = async () => {
    if (!numInput) { showToast("Entrez un numéro de facture", "error"); return; }
    setCreating(true);
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/avoirs/create/${numInput}`, { method: "POST" });
      const data = await r.json();
      showToast(`Avoir créé pour facture #${numInput}`);
      setAvoirs((prev) => [...prev, data]);
      setNumInput("");
    } catch { showToast("Erreur création avoir", "error"); }
    setCreating(false);
  };

  const submitAvoir = async (num) => {
    setModal({ type: "submit", num, loading: true });
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/avoirs/${num}/submit`, { method: "POST" });
      const data = await r.json();
      setModal({ type: "submit", num, data, loading: false });
      showToast(`Avoir #${num} soumis à l'ANCE`);
    } catch { setModal({ type: "submit", num, data: { error: "Erreur" }, loading: false }); }
  };

  const viewAvoir = async (num) => {
    setModal({ type: "detail", num, loading: true });
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/avoirs/${num}`);
      const data = await r.json();
      setModal({ type: "detail", num, data, loading: false });
    } catch { setModal({ type: "detail", num, data: { error: "Erreur" }, loading: false }); }
  };

  const getFactureAvoirs = async (numFacture) => {
    setModal({ type: "facture_avoirs", num: numFacture, loading: true });
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/factures/${numFacture}/avoirs`);
      const data = await r.json();
      setModal({ type: "facture_avoirs", num: numFacture, data, loading: false });
    } catch { setModal({ type: "facture_avoirs", num: numFacture, data: { error: "Erreur" }, loading: false }); }
  };

  const filtered = avoirs.filter((a) => {
    const q = search.toLowerCase();
    return !q ||
      String(a.avoir_number || a.NumAvoir || "").includes(q) ||
      String(a.num_facture || a.NumFacture || "").includes(q) ||
      String(a.statut || a.status || "").toLowerCase().includes(q);
  });

  const statutStyle = (s) => {
    if (!s) return { color: "#6b7280", bg: "#f3f4f6" };
    s = s.toUpperCase();
    if (s === "ACCEPTED" || s === "SOUMIS") return { color: "#16a34a", bg: "#dcfce7" };
    if (s === "REJECTED") return { color: "#dc2626", bg: "#fee2e2" };
    if (s === "PENDING" || s === "CREE") return { color: "#d97706", bg: "#fef3c7" };
    return { color: "#6b7280", bg: "#f3f4f6" };
  };

  return (
    <div style={pg}>
      <Navbar navigate={navigate} active="/avoirs" />
      <div style={container}>
        <div style={{ marginBottom: 28 }}>
          <h1 style={title}>📝 Avoirs électroniques</h1>
          <p style={subtitle}>Gestion des notes de crédit TEIF — Annulation et correction de factures</p>
        </div>

        <div style={{ ...card, marginBottom: 20, borderLeft: "4px solid #6366f1" }}>
          <h3 style={{ margin: "0 0 14px", fontSize: 15, fontWeight: 700 }}>➕ Créer un avoir depuis une facture</h3>
          <div style={{ display: "flex", gap: 10 }}>
            <input
              value={numInput}
              onChange={(e) => setNumInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && createAvoir()}
              placeholder="N° facture (ex: 21)"
              style={{ ...input, flex: 1 }}
            />
            <button onClick={() => getFactureAvoirs(numInput)} disabled={!numInput} style={btnOutline("#0891b2")}>
              🔍 Avoirs de cette facture
            </button>
            <button onClick={createAvoir} disabled={creating || !numInput} style={btnFill("#6366f1")}>
              {creating ? "⏳ Création..." : "✨ Créer avoir"}
            </button>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 16, marginBottom: 24 }}>
          {[
            { label: "Total avoirs", value: avoirs.length, color: "#6366f1", icon: "📝" },
            { label: "Soumis ANCE", value: avoirs.filter((a) => (a.statut || a.status || "").toUpperCase() === "SOUMIS" || (a.statut || "").toUpperCase() === "ACCEPTED").length, color: "#16a34a", icon: "✅" },
            { label: "En attente", value: avoirs.filter((a) => !["SOUMIS", "ACCEPTED"].includes((a.statut || a.status || "").toUpperCase())).length, color: "#d97706", icon: "⏳" },
          ].map((s) => (
            <div key={s.label} style={{ background: "#fff", borderRadius: 12, padding: "18px 20px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: 22 }}>{s.icon}</div>
              <div style={{ fontSize: 22, fontWeight: 800, color: s.color, marginTop: 6 }}>{s.value}</div>
              <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>{s.label}</div>
            </div>
          ))}
        </div>

        <div style={{ ...card, padding: 0, overflow: "hidden" }}>
          <div style={{ padding: "14px 20px", borderBottom: "1px solid #e2e8f0", display: "flex", gap: 12, alignItems: "center" }}>
            <div style={{ position: "relative", flex: 1 }}>
              <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }}>🔍</span>
              <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Rechercher par N° avoir, facture..."
                style={{ ...input, paddingLeft: 36, width: "100%" }} />
            </div>
            <span style={{ color: "#64748b", fontSize: 13 }}>{filtered.length} avoir(s)</span>
          </div>

          {loading ? (
            <div style={{ padding: 60, textAlign: "center", color: "#94a3b8" }}>⏳ Chargement...</div>
          ) : (
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                  {["N° Avoir", "Facture liée", "Montant", "Motif", "Statut", "Actions"].map((h) => (
                    <th key={h} style={{ padding: "12px 16px", textAlign: "left", fontWeight: 600, fontSize: 11, textTransform: "uppercase", letterSpacing: "0.05em", color: "#374151" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr><td colSpan={6} style={{ padding: 60, textAlign: "center", color: "#94a3b8" }}>Aucun avoir trouvé</td></tr>
                ) : filtered.map((a, i) => {
                  const num = a.avoir_number || a.NumAvoir || `AV-${i + 1}`;
                  const facture = a.num_facture || a.NumFacture || "—";
                  const montant = a.montant || a.Montant;
                  const motif = a.motif || a.Motif || "—";
                  const statut = a.statut || a.status || "—";
                  const sc = statutStyle(statut);
                  return (
                    <tr key={i} style={{ borderBottom: "1px solid #f1f5f9" }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = "#fafbff")}
                      onMouseLeave={(e) => (e.currentTarget.style.background = "")}>
                      <td style={{ padding: "12px 16px", fontWeight: 700, color: "#6366f1" }}>#{num}</td>
                      <td style={{ padding: "12px 16px", color: "#475569" }}>
                        <span style={{ cursor: "pointer", color: "#0891b2", textDecoration: "underline" }} onClick={() => navigate("/factures")}>#{facture}</span>
                      </td>
                      <td style={{ padding: "12px 16px", fontWeight: 600 }}>{montant != null ? Number(montant).toFixed(3) + " TND" : "—"}</td>
                      <td style={{ padding: "12px 16px", color: "#64748b" }}>{motif}</td>
                      <td style={{ padding: "12px 16px" }}>
                        <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600, color: sc.color, background: sc.bg }}>{statut}</span>
                      </td>
                      <td style={{ padding: "12px 16px" }}>
                        <div style={{ display: "flex", gap: 6 }}>
                          <Btn onClick={() => viewAvoir(num)} color="#6366f1">🔍 Détail</Btn>
                          <Btn onClick={() => submitAvoir(num)} color="#16a34a">🚀 Soumettre</Btn>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {modal && <Modal modal={modal} onClose={() => setModal(null)} />}
      {toast && <Toast toast={toast} />}
    </div>
  );
}

// ---- Sandbox ANCE ----
export function SandboxANCE() {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [connResult, setConnResult] = useState(null);
  const [sandboxResults, setSandboxResults] = useState(null);
  const [numInput, setNumInput] = useState("");
  const [submitResult, setSubmitResult] = useState(null);
  const [loading, setLoading] = useState({ config: true, conn: false, submit: false });
  const [toast, setToast] = useState(null);

  const showToast = (msg, type = "success") => { setToast({ msg, type }); setTimeout(() => setToast(null), 3500); };

  useEffect(() => {
    Promise.all([
      fetch(`${MIDDLEWARE_URL}/ance/config`).then((r) => r.json()).catch(() => null),
      fetch(`${MIDDLEWARE_URL}/ance/sandbox/results`).then((r) => r.json()).catch(() => null),
    ]).then(([cfg, res]) => {
      setConfig(cfg);
      setSandboxResults(res);
      setLoading((l) => ({ ...l, config: false }));
    });
  }, []);

  const testConnection = async () => {
    setLoading((l) => ({ ...l, conn: true }));
    setConnResult(null);
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/ance/test-connection`);
      const data = await r.json();
      setConnResult(data);
      showToast(data.status === "ok" || data.connected ? "Connexion ANCE réussie ✓" : "Connexion échouée");
    } catch { setConnResult({ error: "Erreur réseau" }); showToast("Erreur connexion", "error"); }
    setLoading((l) => ({ ...l, conn: false }));
  };

  const submitSandbox = async () => {
    if (!numInput) { showToast("Entrez un numéro de facture", "error"); return; }
    setLoading((l) => ({ ...l, submit: true }));
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/ance/sandbox/submit/${numInput}`, { method: "POST" });
      const data = await r.json();
      setSubmitResult(data);
      showToast(`Facture #${numInput} soumise au sandbox ANCE`);
    } catch { setSubmitResult({ error: "Erreur soumission" }); showToast("Erreur", "error"); }
    setLoading((l) => ({ ...l, submit: false }));
  };

  const connOk = connResult?.status === "ok" || connResult?.connected === true;

  return (
    <div style={pg}>
      <Navbar navigate={navigate} active="/sandbox" />
      <div style={container}>
        <div style={{ marginBottom: 28 }}>
          <h1 style={title}>🧪 Sandbox ANCE</h1>
          <p style={subtitle}>Tests d'intégration avec l'environnement officiel de l'ANCE Tunisie</p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
          <div style={card}>
            <h3 style={cardTitle}>⚙️ Configuration ANCE</h3>
            {loading.config ? <Loader /> : config ? (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <Row label="URL" value={config.url || config.dss_url || "—"} />
                <Row label="Mode" value={config.mode || config.environment || "—"} valueColor={config.mode === "production" ? "#dc2626" : "#d97706"} />
                <Row label="Clé API" value={config.api_key ? "••••••••" + config.api_key.slice(-4) : "—"} />
                <Row label="Sandbox" value={config.sandbox_url || "—"} />
              </div>
            ) : <Empty />}
          </div>

          <div style={card}>
            <h3 style={cardTitle}>🔌 Test de Connexion</h3>
            <p style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
              Vérifiez que la connexion vers le serveur ANCE fonctionne correctement.
            </p>
            <button onClick={testConnection} disabled={loading.conn} style={btnFill("#0891b2")}>
              {loading.conn ? "⏳ Test en cours..." : "🔌 Tester la connexion"}
            </button>
            {connResult && (
              <div style={{ marginTop: 14, padding: "12px 16px", borderRadius: 8, background: connOk ? "#dcfce7" : "#fee2e2", border: `1px solid ${connOk ? "#bbf7d0" : "#fecaca"}` }}>
                <div style={{ fontWeight: 700, color: connOk ? "#16a34a" : "#dc2626", fontSize: 14 }}>
                  {connOk ? "✅ Connexion réussie" : "❌ Connexion échouée"}
                </div>
                <pre style={{ margin: "8px 0 0", fontSize: 11, color: "#475569", overflow: "auto" }}>
                  {JSON.stringify(connResult, null, 2)}
                </pre>
              </div>
            )}
          </div>
        </div>

        <div style={{ ...card, marginBottom: 20, borderLeft: "4px solid #d97706" }}>
          <h3 style={{ ...cardTitle, marginBottom: 14 }}>🚀 Soumettre au Sandbox ANCE</h3>
          <p style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
            Testez l'envoi d'une facture vers le sandbox officiel ANCE avant passage en production.
          </p>
          <div style={{ display: "flex", gap: 10 }}>
            <input value={numInput} onChange={(e) => setNumInput(e.target.value)} placeholder="N° facture"
              onKeyDown={(e) => e.key === "Enter" && submitSandbox()}
              style={{ ...input, flex: 1 }} />
            <button onClick={submitSandbox} disabled={loading.submit || !numInput} style={btnFill("#d97706")}>
              {loading.submit ? "⏳ Envoi..." : "🚀 Soumettre Sandbox"}
            </button>
          </div>
          {submitResult && (
            <div style={{ marginTop: 14 }}>
              <pre style={{ margin: 0, fontSize: 11, background: "#0f172a", color: "#e2e8f0", padding: 16, borderRadius: 8, overflow: "auto", maxHeight: 200 }}>
                {JSON.stringify(submitResult, null, 2)}
              </pre>
            </div>
          )}
        </div>

        <div style={card}>
          <h3 style={cardTitle}>📋 Derniers résultats Sandbox</h3>
          {sandboxResults ? (
            <pre style={{ margin: 0, fontSize: 11, background: "#0f172a", color: "#e2e8f0", padding: 16, borderRadius: 8, overflow: "auto", maxHeight: 300 }}>
              {JSON.stringify(sandboxResults, null, 2)}
            </pre>
          ) : <Empty msg="Aucun résultat disponible" />}
        </div>
      </div>
      {toast && <Toast toast={toast} />}
    </div>
  );
}

// ---- Offline Mode ----
export function OfflineMode() {
  const navigate = useNavigate();
  const [queue, setQueue] = useState([]);
  const [offlineStatus, setOfflineStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [retrying, setRetrying] = useState(false);
  const [numInput, setNumInput] = useState("");
  const [submitOfflineResult, setSubmitOfflineResult] = useState(null);
  const [toast, setToast] = useState(null);

  const showToast = (msg, type = "success") => { setToast({ msg, type }); setTimeout(() => setToast(null), 3500); };

  const fetchData = () => {
    Promise.all([
      fetch(`${MIDDLEWARE_URL}/offline/queue`).then((r) => r.json()).catch(() => []),
      fetch(`${MIDDLEWARE_URL}/offline/status`).then((r) => r.json()).catch(() => null),
    ]).then(([q, st]) => {
      setQueue(Array.isArray(q) ? q : q?.queue || []);
      setOfflineStatus(st);
      setLoading(false);
    });
  };

  useEffect(() => { fetchData(); }, []);

  const syncOffline = async () => {
    setSyncing(true);
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/offline/sync`, { method: "POST" });
      const data = await r.json();
      showToast(`Synchronisation lancée — ${data.sent || 0} facture(s) envoyée(s)`);
      fetchData();
    } catch { showToast("Erreur synchronisation", "error"); }
    setSyncing(false);
  };

  const retryFailed = async () => {
    setRetrying(true);
    try {
      await fetch(`${MIDDLEWARE_URL}/offline/retry-failed`, { method: "POST" });
      showToast("Retry des factures échouées lancé");
      fetchData();
    } catch { showToast("Erreur retry", "error"); }
    setRetrying(false);
  };

  const submitOffline = async () => {
    if (!numInput) { showToast("Entrez un numéro de facture", "error"); return; }
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/factures/${numInput}/submit-offline`, { method: "POST" });
      const data = await r.json();
      setSubmitOfflineResult(data);
      showToast(`Facture #${numInput} mise en file offline`);
      fetchData();
    } catch { showToast("Erreur", "error"); }
  };

  const isOnline = offlineStatus?.connection_available || offlineStatus?.online;
  const queueSize = offlineStatus?.queue_size ?? queue.length;

  return (
    <div style={pg}>
      <Navbar navigate={navigate} active="/offline" />
      <div style={container}>
        <div style={{ marginBottom: 28, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
          <div>
            <h1 style={title}>📴 Mode Offline</h1>
            <p style={subtitle}>Gestion des factures en file d'attente — Synchronisation automatique</p>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={retryFailed} disabled={retrying} style={btnOutline("#dc2626")}>
              {retrying ? "⏳" : "🔁"} Retry échouées
            </button>
            <button onClick={syncOffline} disabled={syncing} style={btnFill("#16a34a")}>
              {syncing ? "⏳ Sync..." : "🔄 Synchroniser maintenant"}
            </button>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 16, marginBottom: 24 }}>
          {[
            { label: "Connexion", value: loading ? "..." : (isOnline ? "En ligne" : "Hors ligne"), color: isOnline ? "#16a34a" : "#dc2626", icon: isOnline ? "🟢" : "🔴" },
            { label: "File d'attente", value: loading ? "..." : queueSize, color: queueSize > 0 ? "#d97706" : "#16a34a", icon: "📋" },
            { label: "Dernière sync", value: offlineStatus?.last_sync ? new Date(offlineStatus.last_sync).toLocaleTimeString("fr-FR") : "—", color: "#6366f1", icon: "🕐" },
            { label: "Échouées", value: loading ? "..." : (queue.filter((q) => q.status === "FAILED" || q.statut === "FAILED").length), color: "#dc2626", icon: "⚠️" },
          ].map((s) => (
            <div key={s.label} style={{ background: "#fff", borderRadius: 12, padding: "18px 20px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: 22 }}>{s.icon}</div>
              <div style={{ fontSize: s.label === "Dernière sync" ? 14 : 22, fontWeight: 800, color: s.color, marginTop: 6 }}>{s.value}</div>
              <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 4 }}>{s.label}</div>
            </div>
          ))}
        </div>

        <div style={{ ...card, marginBottom: 20, borderLeft: "4px solid #6366f1" }}>
          <h3 style={{ ...cardTitle, marginBottom: 12 }}>📤 Soumettre une facture en mode offline</h3>
          <div style={{ display: "flex", gap: 10 }}>
            <input value={numInput} onChange={(e) => setNumInput(e.target.value)} placeholder="N° facture"
              onKeyDown={(e) => e.key === "Enter" && submitOffline()}
              style={{ ...input, flex: 1 }} />
            <button onClick={submitOffline} disabled={!numInput} style={btnFill("#6366f1")}>
              📴 Ajouter à la file offline
            </button>
          </div>
          {submitOfflineResult && (
            <div style={{ marginTop: 12, padding: "10px 14px", borderRadius: 8, background: "#f0f9ff", border: "1px solid #bae6fd", fontSize: 13 }}>
              ✅ <pre style={{ display: "inline", fontSize: 11 }}>{JSON.stringify(submitOfflineResult, null, 2)}</pre>
            </div>
          )}
        </div>

        <div style={{ ...card, padding: 0, overflow: "hidden" }}>
          <div style={{ padding: "16px 20px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>📋 File d'attente ({queue.length})</h3>
            <button onClick={fetchData} style={btnOutline("#6366f1")}>🔄 Actualiser</button>
          </div>
          {loading ? <Loader /> : (
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                  {["N° Facture", "Ajouté le", "Tentatives", "Statut"].map((h) => (
                    <th key={h} style={{ padding: "12px 16px", textAlign: "left", fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", color: "#374151" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {queue.length === 0 ? (
                  <tr><td colSpan={4} style={{ padding: 50, textAlign: "center", color: "#16a34a" }}>
                    <div style={{ fontSize: 32 }}>✅</div>
                    <div style={{ marginTop: 8, fontSize: 13 }}>File vide — toutes les factures sont synchronisées</div>
                  </td></tr>
                ) : queue.map((q, i) => {
                  const st = (q.status || q.statut || "").toUpperCase();
                  const stStyle = st === "FAILED" ? { color: "#dc2626", bg: "#fee2e2" } : st === "PENDING" ? { color: "#d97706", bg: "#fef3c7" } : { color: "#16a34a", bg: "#dcfce7" };
                  return (
                    <tr key={i} style={{ borderBottom: "1px solid #f1f5f9" }}>
                      <td style={{ padding: "12px 16px", fontWeight: 700, color: "#6366f1" }}>#{q.num_facture || q.NumFacture || "—"}</td>
                      <td style={{ padding: "12px 16px", color: "#64748b" }}>{q.added_at ? new Date(q.added_at).toLocaleString("fr-FR") : "—"}</td>
                      <td style={{ padding: "12px 16px", color: "#475569" }}>{q.attempts || q.tentatives || 0}</td>
                      <td style={{ padding: "12px 16px" }}>
                        <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600, color: stStyle.color, background: stStyle.bg }}>{st || "—"}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
      {toast && <Toast toast={toast} />}
    </div>
  );
}

// ---- Multi-Sociétés ----
export function MultiSocietes() {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [toast, setToast] = useState(null);

  const showToast = (msg, type = "success") => { setToast({ msg, type }); setTimeout(() => setToast(null), 3500); };

  const fetchCompanies = () => {
    fetch(`${MIDDLEWARE_URL}/companies`)
      .then((r) => r.json())
      .then((d) => { setCompanies(Array.isArray(d) ? d : d.companies || []); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => { fetchCompanies(); }, []);

  const viewCompany = async (id) => {
    setModal({ type: "detail", id, loading: true });
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/companies/${id}`);
      const data = await r.json();
      setModal({ type: "detail", id, data, loading: false });
    } catch { setModal({ type: "detail", id, data: { error: "Erreur" }, loading: false }); }
  };

  const viewCert = async (id) => {
    setModal({ type: "cert", id, loading: true });
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/companies/${id}/certificate`);
      const data = await r.json();
      setModal({ type: "cert", id, data, loading: false });
    } catch { setModal({ type: "cert", id, data: { error: "Erreur" }, loading: false }); }
  };

  const viewStats = async (id) => {
    setModal({ type: "stats", id, loading: true });
    try {
      const r = await fetch(`${MIDDLEWARE_URL}/companies/${id}/stats`);
      const data = await r.json();
      setModal({ type: "stats", id, data, loading: false });
    } catch { setModal({ type: "stats", id, data: { error: "Erreur" }, loading: false }); }
  };

  // ── Nouvelle facture pour une société donnée ────────────────────────────
  const goToNewFacture = (id) => {
    document.cookie = `societe_id=${id};path=/;SameSite=Strict;Max-Age=86400`;
    navigate("/facture/create");
  };

  return (
    <div style={pg}>
      <Navbar navigate={navigate} active="/societes" />
      <div style={container}>
        <div style={{ marginBottom: 28, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
          <div>
            <h1 style={title}>🏢 Multi-Sociétés</h1>
            <p style={subtitle}>Gestion des sociétés et leurs certificats électroniques</p>
          </div>
          {/* ← BOUTON ONBOARDING */}
          <button onClick={() => navigate("/societes/new")} style={btnFill("#6366f1")}>
            ➕ Nouvelle société
          </button>
        </div>

        {loading ? <Loader /> : companies.length === 0 ? (
          <div style={{ ...card, textAlign: "center", padding: 60 }}>
            <div style={{ fontSize: 40 }}>🏢</div>
            <div style={{ marginTop: 12, color: "#64748b" }}>Aucune société enregistrée</div>
            {/* ← BOUTON ONBOARDING */}
            <button onClick={() => navigate("/societes/new")} style={{ ...btnFill("#6366f1"), marginTop: 16 }}>
              ➕ Créer la première société
            </button>
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))", gap: 18 }}>
            {companies.map((c, i) => {
              const id = c.id || c.company_id || i;
              const name = c.name || c.nom || c.NomSociete || `Société ${i + 1}`;
              const mf = c.matricule_fiscal || c.MatriculeFiscal || "—";
              const adresse = c.adresse || c.Adresse || "—";
              const deleteCompany = async (id, name) => {
  if (!window.confirm(`⚠️ Supprimer la société "${name}" ?\nCette action est irréversible.`)) return;
  try {
    const r = await fetch(`${MIDDLEWARE_URL}/companies/${id}`, { method: "DELETE" });
    if (r.ok) {
      showToast(`Société "${name}" supprimée`);
      fetchCompanies();
    } else {
      showToast("Erreur suppression", "error");
    }
  } catch {
    showToast("Erreur réseau", "error");
  }
};
              return (
                <div key={id} style={{ ...card, position: "relative", overflow: "hidden" }}>
                  <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 4, background: "linear-gradient(90deg,#6366f1,#8b5cf6)" }} />
                  <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 16 }}>
                    <div style={{ width: 48, height: 48, borderRadius: 12, background: "#eef2ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>🏢</div>
                    <span style={{ fontSize: 11, padding: "3px 8px", borderRadius: 20, background: "#eef2ff", color: "#6366f1", fontWeight: 600 }}>ID: {id}</span>
                  </div>
                  <h3 style={{ margin: "0 0 6px", fontSize: 16, fontWeight: 700 }}>{name}</h3>
                  <div style={{ fontSize: 12, color: "#64748b", marginBottom: 4 }}>📋 {mf}</div>
                  <div style={{ fontSize: 12, color: "#64748b", marginBottom: 16 }}>📍 {adresse}</div>

                  {/* ← BOUTON NOUVELLE FACTURE — uniquement pour les sociétés
                       SANS DAS ERP (client_type === "standalone").
                       ⚠️ Nécessite que le backend renvoie ce champ dans /companies
                       (ex: c.client_type, ou c.has_erp === false). Si le champ
                       n'existe pas encore côté backend, le bouton reste caché
                       par sécurité (via isStandalone ci-dessous). */}
                  {(c.client_type === "standalone" || c.has_erp === false) && (
                    <button
                      onClick={() => goToNewFacture(id)}
                      style={{ ...btnFill("#d97706"), width: "100%", marginBottom: 10 }}
                    >
                      🧾 Nouvelle facture
                    </button>
                  )}

                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <Btn onClick={() => viewCompany(id)} color="#6366f1">🔍 Détails</Btn>
                    <Btn onClick={() => viewCert(id)} color="#0891b2">🔒 Certificat</Btn>
                    <Btn onClick={() => viewStats(id)} color="#16a34a">📊 Stats</Btn>
                    <Btn onClick={() => deleteCompany(id, name)} color="#dc2626">🗑️ Supprimer</Btn>

                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {modal && <Modal modal={modal} onClose={() => setModal(null)} title={
        modal.type === "detail" ? `🏢 Détails Société #${modal.id}` :
        modal.type === "cert" ? `🔒 Certificat Société #${modal.id}` :
        `📊 Statistiques Société #${modal.id}`
      } />}
      {toast && <Toast toast={toast} />}
    </div>
  );
}

// ===== SHARED COMPONENTS =====

// Lit le type de client sauvegardé lors de l'onboarding (voir CompanyOnboarding.js)
// "erp"        → société déjà connue par DAS ERP, les factures arrivent par sync automatique
// "standalone" → nouvelle société (créée uniquement en PostgreSQL), pas d'ERP derrière,
//                elle a besoin de créer ses factures manuellement dans la plateforme
function getClientType() {
  const match = document.cookie.match(/(^| )client_type=([^;]+)/);
  return match ? decodeURIComponent(match[2]) : "erp"; // "erp" par défaut (comportement historique)
}

function Navbar({ navigate, active }) {
  const clientType = getClientType();
  const isStandalone = clientType === "standalone";

  const navItems = [
    ["🧾", "Factures", "/factures"],
    // "Nouvelle facture" n'apparaît que pour les clients SANS DAS ERP —
    // les clients ERP reçoivent leurs factures automatiquement par sync.
    ...(isStandalone ? [["✨", "Nouvelle facture", "/facture/create"]] : []),
    ["🗄️", "Archive", "/archive"],
    ["🔍", "Traçabilité", "/tracabilite"],
    ["📡", "Dashboard", "/dashboard"],
    ["📝", "Avoirs", "/avoirs"],
    ["🧪", "Sandbox", "/sandbox"],
    ["📴", "Offline", "/offline"],
    ["🏢", "Sociétés", "/societes"],
  ];

  return (
    <nav style={{
      background: "#fff", borderBottom: "1px solid #e2e8f0", padding: "0 32px",
      display: "flex", alignItems: "center", justifyContent: "space-between", height: 64,
      position: "sticky", top: 0, zIndex: 100, boxShadow: "0 1px 3px rgba(0,0,0,.05)"
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
        <div onClick={() => navigate("/home")} style={{ cursor: "pointer" }}>
          <span style={{ fontSize: 20, fontWeight: 800, background: "linear-gradient(135deg,#6366f1,#8b5cf6)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>⚡ LOGIMES</span>
        </div>
        <div style={{ display: "flex", gap: 2 }}>
          {navItems.map(([icon, label, path]) => (
            <button key={path} onClick={() => navigate(path)} style={{
              padding: "5px 11px", borderRadius: 7, border: "none", cursor: "pointer", fontSize: 12, fontWeight: 500,
              background: active === path ? "#f0f0ff" : "transparent",
              color: active === path ? "#6366f1" : "#64748b",
            }}>{icon} {label}</button>
          ))}
        </div>
      </div>
      <button onClick={() => { localStorage.removeItem("token"); navigate("/"); }} style={{
        padding: "7px 16px", borderRadius: 8, border: "1.5px solid #e2e8f0", background: "#fff", color: "#64748b", fontSize: 12, fontWeight: 500, cursor: "pointer"
      }}>Déconnexion</button>
    </nav>
  );
}

function Modal({ modal, onClose, title }) {
  const t = title || (modal.type === "submit" ? `🚀 Soumission #${modal.num}` : modal.type === "detail" ? `🔍 Détail #${modal.num}` : modal.type === "facture_avoirs" ? `📝 Avoirs Facture #${modal.num}` : `#${modal.num}`);
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 760, maxHeight: "85vh", display: "flex", flexDirection: "column", boxShadow: "0 25px 50px rgba(0,0,0,.25)" }}>
        <div style={{ padding: "18px 24px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>{t}</h2>
          <button onClick={onClose} style={{ border: "none", background: "none", fontSize: 20, cursor: "pointer", color: "#94a3b8" }}>✕</button>
        </div>
        <div style={{ flex: 1, overflow: "auto", padding: 24 }}>
          {modal.loading ? <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>⏳ Chargement...</div> : (
            <pre style={{ margin: 0, fontSize: 12, background: "#0f172a", color: "#e2e8f0", padding: 20, borderRadius: 10, overflow: "auto", lineHeight: 1.6 }}>
              {JSON.stringify(modal.data, null, 2)}
            </pre>
          )}
        </div>
      </div>
    </div>
  );
}

function Toast({ toast }) {
  return (
    <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 300, background: toast.type === "error" ? "#dc2626" : "#16a34a", color: "#fff", padding: "12px 20px", borderRadius: 10, fontSize: 13, fontWeight: 500, boxShadow: "0 8px 24px rgba(0,0,0,.2)" }}>
      {toast.type === "error" ? "❌" : "✅"} {toast.msg}
    </div>
  );
}

function Row({ label, value, valueColor = "#475569" }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #f1f5f9" }}>
      <span style={{ fontSize: 13, color: "#94a3b8" }}>{label}</span>
      <span style={{ fontSize: 13, fontWeight: 600, color: valueColor, maxWidth: "60%", textAlign: "right", wordBreak: "break-all" }}>{String(value)}</span>
    </div>
  );
}

function Btn({ onClick, color, children }) {
  return (
    <button onClick={onClick} style={{ padding: "5px 10px", borderRadius: 6, fontSize: 12, fontWeight: 500, cursor: "pointer", border: `1.5px solid ${color}`, background: "#fff", color, transition: "all .15s", whiteSpace: "nowrap" }}
      onMouseEnter={(e) => { e.currentTarget.style.background = color; e.currentTarget.style.color = "#fff"; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.color = color; }}>
      {children}
    </button>
  );
}

function Loader() { return <div style={{ padding: 40, textAlign: "center", color: "#94a3b8" }}>⏳ Chargement...</div>; }
function Empty({ msg = "Données non disponibles" }) { return <div style={{ padding: "20px 0", color: "#94a3b8", fontSize: 13 }}>{msg}</div>; }

const pg = { minHeight: "100vh", background: "#f8fafc", fontFamily: "'Segoe UI', system-ui, sans-serif" };
const container = { maxWidth: 1400, margin: "0 auto", padding: "32px 24px" };
const title = { fontSize: 26, fontWeight: 700, color: "#0f172a", margin: 0 };
const subtitle = { color: "#64748b", margin: "4px 0 0", fontSize: 14 };
const card = { background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: 24, boxShadow: "0 1px 3px rgba(0,0,0,.04)" };
const cardTitle = { margin: 0, fontSize: 15, fontWeight: 700, color: "#0f172a" };
const input = { width: "100%", height: 40, padding: "0 12px", borderRadius: 8, border: "1.5px solid #e2e8f0", fontSize: 13, outline: "none", background: "#fff", color: "#0f172a", boxSizing: "border-box" };
const labelStyle = { display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 };

const btnFill = (color) => ({
  padding: "9px 18px", borderRadius: 8, border: "none", background: color, color: "#fff",
  fontSize: 13, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap",
  boxShadow: `0 4px 12px ${color}35`
});
const btnOutline = (color) => ({
  padding: "9px 18px", borderRadius: 8, border: `1.5px solid ${color}`, background: "#fff", color,
  fontSize: 13, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap"
});